import {useUniqueId} from "../../utils";
import { ReactNode, useCallback } from "react";

import './Counter.css';

export default function Counter({value, setValue, label, limit, color, className, conflict} : {
    value: number,
    setValue: (val : number) => void,
    label: ReactNode,
    limit?: number,
    color?: 'RED' | 'red' | 'BLUE' | 'blue',
    className?: string,
    conflict?: boolean
}) {
    const id = useUniqueId();

    const decrement = useCallback(() => {
        const oldValue = value || 0;
        let newValue = oldValue - 1;
        if(newValue < 0) {
            newValue = 0;
        }
        if(newValue !== oldValue) {
            setValue(newValue)
        }
    }, [value]);

    const increment = useCallback(() => {
        const oldValue = Math.max(value || 0, 0); // if null (-1), '+' sets it to 1, '-' sets it to 0
        let newValue = oldValue + 1;
        if(limit && newValue > limit) {
            newValue = limit;
        }
        if(newValue !== oldValue) {
            setValue(newValue)
        }
    }, [value]);

    return <div className={`d-flex align-items-center mb-2 ${className || ''} counter-wrapper ${conflict ? "conflict" : ""}`}>
        <label htmlFor={id} className={"flex-grow-1"}>{label}</label>
        <div className="input-group counter-input-group">
            <div className="input-group-prepend flex-grow-1">
                <button className={`btn counterButton w-100`} onClick={decrement}>
                    <i className="fa fa-minus-square fa-2x" aria-hidden="true"></i>
                </button>
            </div>
            <input className={`form-control text-center counter`} id={id} value={value < 0 ? '' : value || 0} readOnly/>
            <div className="input-group-append flex-grow-1">
                <button className={`btn counterButton w-100 ${color ? color.toLowerCase() : ''}`} onClick={increment}>
                    <i className="fa fa-plus-square fa-2x" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>

}